import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  SetSocket: "[Load Socket] Action",
  SetIdle: "[Set Idle] Set Idle",
  SetCounter:"[Set Counter] Set Counter",
  SetIdleEncounter:"[Set IDLE ENCOUNTER] Set Idle Encounter",
};

const initialAuthState = {
  user: undefined,
  practice_id: undefined,
  authToken: undefined,
  practices: undefined,
  socket: null,
  isIdle: false,
  counter: 0,
  idleEncounters: []
};

export const reducer = persistReducer(
  {
    storage,
    key: "ethizo",
    whitelist: ["authToken", "user", "practice_id", "id","isIdle","idleEncounters"],
  },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { authToken } = action.payload;
        return { ...state, authToken };
      }
      case actionTypes.Logout: {
        // TODO: Change this code. Actions in reducer aren't allowed.
        return initialAuthState;
      }
      case actionTypes.UserLoaded: {
        const { user, practice_id } = action.payload;
        return { ...state, user, practice_id: practice_id };
      }
      case actionTypes.SetSocket: {
        const { socket } = action.payload;
        return { ...state, socket };
      }
      case actionTypes.SetIdle: {
        const { isIdle } = action.payload;
        return { ...state, isIdle };
      }
      case actionTypes.SetCounter: {
        const { counter } = action.payload;
        return { ...state, counter };
      }
      case actionTypes.SetIdleEncounter: {
        const { idleEncounters } = action.payload;
        return { ...state, idleEncounters : idleEncounters };
      }
      default:
        return state;
    }
  }
);

export const actions = {
  login: (authToken) => ({
    type: actionTypes.Login,
    payload: { authToken },
  }),
  setSocket: (socket) => {
    return {
      type: actionTypes.SetSocket,
      payload: { socket },
    };
  },
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  fulfillUser: (user, practice_id) => ({
    type: actionTypes.UserLoaded,
    payload: { user, practice_id },
  }),
  setIsIdle: (isIdle) => ({
    type: actionTypes.SetIdle,
    payload: { isIdle }
  }),
  setCounter: (counter) => ({
    type: actionTypes.SetCounter,
    payload: { counter }
  }),
  setIdleEncounter: (idleEncounters) => ({
    type: actionTypes.SetIdleEncounter,
    payload: { idleEncounters }
  })
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestPractices());
  });

}
